<div class="wrapper">
    <div class="content">
        <div class="header">
            Your Group Class ({{ classTitle }})
            <ng-container *ngIf="isUpdating; else showDefault">has been updated!</ng-container
            ><ng-template #showDefault>is Ready!</ng-template>
        </div>

        <p class="content__body">Please click the URL below to copy your class link:</p>
        <p class="content__body link">
            <a
                #inviteLink
                href="#"
                class="invite-link"
                data-position="bottom center"
                (click)="handleCopyLink(schedulingLink)"
            >
                {{ schedulingLink }}
            </a>
        </p>

        <p class="content__body light">
            Your link is unique to this class. Once you share your link, go to
            <a href="/tasks/upcoming">Upcoming Tasks</a> to track the scheduling progress.
            <a href="https://faq.calendarhero.com/article/232-how-to-schedule-a-group-class" target="_blank">
                Learn More
            </a>
        </p>

        <p class="content__body light">
            Need a public landing page to display multiple classes?
            <a href="/settings/meeting/directories">Create a Directory</a>
        </p>
    </div>
    <div class="image">
        <img class="ui image" src="/assets/images/time-selection.svg" />
    </div>
</div>
